import React from 'react';
import { DividendPredictionModal } from './DividendClassification';
import { formatDate } from 'utils/formatter';
import { FooterText, DividendHeader } from 'pages/DividendPrediction';
import Loading from 'components/commons/loading/Loading';

export const DividendNoData = () => {
  return (
    <>
      <DividendHeader {...{ type: 'prediction' }} />
      <div className="bg-white text-bluegray-700">
        <div className="flex flex-row justify-center pt-6 px-4 font-bold">
          {formatDate(new Date(), 'yyyy年 M月')}
        </div>
        <div className="px-4 text-center text-xs">
          <span className="mr-1 text-2xl font-bold">---</span>円
        </div>
        <DividendPredictionModal />
        <div className="flex mt-4">
          <img
            src="/static/images/dividend/dividend_no_data.png"
            alt=""
            className="mx-auto"
            height="150"
            width="315"
          />
        </div>
        <div
          className="grid mx-4 px-4 py-1 pl-2 mt-4 text-sm text-bluegray-550 font-bold bg-gray-300"
          style={{ gridTemplateColumns: '1fr 1fr' }}>
          <div>銘柄</div>
          <div>配当額</div>
        </div>
        <div className="flex flex-row items-center pl-6 pr-4 pt-2 pb-8">
          <div className="font-bold">合計</div>
          <div className="ml-auto">
            <span className="mr-1 text-lg font-bold">---</span>円
          </div>
        </div>
      </div>
      <FooterText />
    </>
  );
};

export const DividendPredictionLoading = ({ str }: { str: string }) => {
  return (
    <>
      <DividendHeader {...{ type: 'prediction' }} />
      <div className="bg-white text-bluegray-700">
        <div className="flex flex-row justify-center pt-6 mx-auto">
          <div className="text-sm font-bold">----年</div>
        </div>
        <div className="px-4 mt-2 text-center text-xs">
          <span className="mr-1 text-2xl font-bold">---</span>円
        </div>
        <Loading
          loading={true}
          circularLoading={true}
          style={{
            paddingTop: '90px',
            paddingBottom: '90px',
          }}
        />
        <div
          className="grid px-4 py-1 text-sm text-bluegray-550 font-bold bg-gray-300"
          style={{ gridTemplateColumns: '1fr 1fr' }}>
          <div className="ml-2">{str}</div>
          <div>予想額</div>
        </div>
        <div className="pb-6">
          <Loading
            loading={true}
            circularLoading={true}
            style={{
              paddingTop: '170px',
              paddingBottom: '170px',
            }}
          />
        </div>
      </div>
      <FooterText />
    </>
  );
};
